import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUserVerifyFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m19.793 16.886-.204-.204c-.204-.204-.204-.306-.204-.612v-.408a.914.914 0 0 0-.918-.919h-.409c-.204 0-.408-.102-.612-.204l-.204-.204c-.306-.306-.918-.306-1.224 0l-.205.204c-.204.204-.306.204-.612.204h-.408a.914.914 0 0 0-.918.919v.408c0 .204-.102.408-.204.612l-.204.204c-.307.306-.307.918 0 1.224l.204.205c.204.204.204.306.204.612v.408c0 .51.408.918.918.918h.408c.204 0 .408.102.612.204l.205.204c.306.307.918.307 1.224 0l.204-.204c.204-.204.306-.204.612-.204h.41c.51 0 .917-.408.917-.918v-.408c0-.204.102-.408.204-.612l.204-.205c.306-.306.306-.816 0-1.224m-1.735.408-1.53 1.429c-.102.102-.204.204-.408.204s-.307-.102-.409-.204l-.714-.715c-.204-.204-.204-.612 0-.816s.612-.204.816 0l.307.306 1.02-1.02c.204-.204.612-.204.816 0s.306.51.102.816M15.814 7.803c.102-2.653-2.041-4.694-4.694-4.694a4.68 4.68 0 0 0-4.694 4.694 4.68 4.68 0 0 0 4.694 4.694 4.68 4.68 0 0 0 4.694-4.694M10.1 14.54c-1.43 0-2.755.203-3.775.51-.613.203-1.225.51-1.633.918a2.46 2.46 0 0 0-.714 1.734c0 .714.204 1.225.714 1.735.408.408 1.02.714 1.633.918 1.02.306 2.346.51 3.775.51.611 0 1.02-.408 1.02-1.02V15.56c0-.612-.409-1.02-1.02-1.02"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUserVerifyFilled);
export default ForwardRef;
